import React, { useEffect, useState, useRef, useCallback } from 'react'
import { TelaEntrega } from "./TelaEntrega";
import { obterParametros, obterParametrosPorOidItem } from "../../use-cases/parametro/obterParametros";
import { Parametro, ParametroPorItem } from "../../types/Parametro";
import globalMU from "../../../globalMU";
import microuniversoApi from "../../api/microuniversoApi";
import { IOrcamento } from "../../types/IOrcamento";
import { useAppSelector } from "../../redux/hooks";
import { tratamentoErroPadrao } from "../../use-cases";
import { DadosEntrega } from "../../types/DadosEntrega";
import { obterPermissao } from "../../use-cases/obterPermissao";
import { atualizarEntrega } from "../../use-cases/orcamento/atualizarEntrega";
import { Entrega } from "./aba-entrega/aba-entrega";
import { DadosTransportadora } from "../../types/DadosTransportadora";
import { DefinirTransportadora } from "../../use-cases/orcamento/DefinirTransportadora";
import { Transportadora } from "../../types/AbaTransportadora";
import { Frete } from "./frete/AbaFrete";
import { TipoEntrega } from "./aba-tipo-entrega/AbaTipoEntrega";
import { renderizarComponentReact } from "../renderizarOuRemoverComponentReact";
import { EditarTipoEntregaContainer } from "./aba-tipo-entrega/editar-tipo-entrega/EditarTipoEntregaContainer";
import { EditarFreteContainer } from "./frete/Editar-frete/EditarFreteContainer";
import store from 'app/redux/store/store';
import { atualizarItensAction } from 'app/redux/orcamentoSlice';
import { gravarTelasAlteradasSalvaAction, gravarTelasAlteradasNaoSalvaAction } from 'app/redux/telaOrcamentoAlteradaNaoSalvaSlice';
import { atualizarCamposPendentesOrcamentoEmAndamentoAction } from 'app/redux/orcamentoEmAndamentoSlice';
export type NomeTela = "Entrega" | "Transportadora" | "Frete" | "Tipo Entrega"

export type TelaEntregaContainerProps = {
    telaDefault?: NomeTela
}


export const TelaEntregaContainer = (props: TelaEntregaContainerProps) => {
    const isMounted = useRef<boolean>(true)
    useEffect(() => () => { isMounted.current = false }, [])
    const [permitidoAlterarEntrega, setPermitidoAlterarEntrega] = useState<boolean>(true)
    const [permitidoEditarFrete, setPermitidoEditarFrete] = useState<boolean>(true)
    const [permitidoEditarTipoEntrega, setPermitidoEditarTipoEntrega] = useState<boolean>(true)
    const [permitidoFrete, setPermitidoFrete] = useState<boolean>(true)
    const [dados, setDados] = useState<DadosEntrega>({} as DadosEntrega)
    const [telaExibida, setTelaExibida] = useState<NomeTela>("Entrega")
    const [tiposEntrega, setTiposEntrega] = useState<TipoEntrega[]>([])
    const [fretes, setFretes] = useState<Frete[]>([])
    const [dadosTransportadora, setDadosTransportadora] = useState<DadosTransportadora>({
        RoteiroObrigatorio: false,
        PermitirAlterarRoteiro: false,
        TiposFrete: [],
        Transportadoras: [],
        TransportadorasRedespacho: [],        
        Roteiros: [],
        IndicadoresDePresenca: [],
        TipoOrcamento: 0,
        Transportadora: {
            CodigoRoteiroEntrega: "",
            CodigoTransportadora: "",
            TipoTransportadora: "",
            CodigoIndicadorDePresenca: "", // 458066
            CodigoTransportadoraRedespacho: "",
            TipoFrete: "",
            ClassificacaoFrete: "",
            ValorCustoFrete: 0,
            HabilitaEdicaoCustoFrete: false,
            CustoFretePendente: false,
            Transforming: false,
        },
    })
    const [parametros, setParametros] = useState<Parametro[]>([])
    const [parametrosPorFilial, setParametrosPorFilial] = useState<ParametroPorItem[]>([])
    const [permitidoIncluir, setPermitidoIncluir] = useState<boolean>(false)
    const [permitidoAlterar, setPermitidoAlterar] = useState<boolean>(false)
    const [carregando , setCarregando] = useState(true)
    const [obtendoPemissoes , setObtendoPemissoes] = useState(false)
    const [dataMaximaParaPrevisaoEntrega, setDataMaximaParaPrevisaoEntrega] = useState<{ year: number, month: number, day: number }>(null)
    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento)

    const valorParametro = useCallback((nome: string) => parametros.find(p => p.Nome == nome)?.Valor, [parametros])
    const valorParametroPorFilial = useCallback((nome: string) => parametrosPorFilial.find((p) => p.Nome == nome)?.Valor, [parametrosPorFilial])

    const obterPermissoes = async () => {
        setObtendoPemissoes(true)
        setPermitidoAlterarEntrega(await permitidoAcaoFuncionalidade("ORCAMENTO_ENTREGA", "ALTERAR"))
        setPermitidoFrete(await permitidoAcaoFuncionalidade("ORCAMENTO_FRETE", "CONSULTAR"))
        setPermitidoEditarTipoEntrega(await permitidoAcaoFuncionalidade("ORCAMENTO_TIPO_ENTREGA", "ALTERAR"))
        setPermitidoEditarFrete(await permitidoAcaoFuncionalidade("ORCAMENTO_FRETE", "ALTERAR"))
        setObtendoPemissoes(false)
    }

    const atualizarParametros = async () => {
        try 
        {
            const parametros = await obterParametros({
                    nomes: [
                        "UTILIZA_CALCULO_FRETE_FAIXA_MARKUP",
                        "DEFINIR_PREVISAO_ENTREGA_POR_ITEM",
                        //por filial"VENDA_COM_ENTREGA_POSTERIOR",
                        "UTILIZA_FRETE_CARGA",
                        "UTILIZAR_BAIRROS_PRE_CADASTRADOS",
                        //por filial "ROTEIRO_OBRIGATORIO_ORCAMENTO",
                        "VENDA_ENTREGA_EXPRESSA",
                        "CHAVE_MOVIMENTACAO_ORCAMENTO"
                    ]
                })

            if (isMounted.current)
                setParametros(parametros)

            const parametrosFilial = await obterParametrosPorOidItem({// 433263
                    nomes: [
                    "VENDA_COM_ENTREGA_POSTERIOR",
                    "ROTEIRO_OBRIGATORIO_ORCAMENTO",
                    "OBRIGATORIO_INFORMAR_TURNO_ORCAMENTO"
                ],
                    oidItem: orcamento.OidFilialOrcamento
                })

            if (isMounted.current)
                setParametrosPorFilial(parametrosFilial) // 433263
            if (parametrosFilial.find(p => p.Nome == "OBRIGATORIO_INFORMAR_TURNO_ORCAMENTO")?.Valor == "S" && parametros.find(p => p.Nome == "DEFINIR_PREVISAO_ENTREGA_POR_ITEM")?.Valor != "S") //475897
            {
                globalMU.showWarnMessage('O parâmetro [Definir previsão de entrega por item] deve estar ligado. A funcionalidade [Obrigar o usuário a informar o Turno no orçamento] foi desativada.') //475897
            }
        }
        catch (e) {
            if (isMounted.current)
                tratamentoErroPadrao(e)
        }
    }

    const permitidoAcaoFuncionalidade = async (siglaFuncionalidade: string, acao?: string) => await obterPermissao({ funcionalidade: siglaFuncionalidade, acao })

    const atualizarPermissoes = async () => {
        const incluir = await permitidoAcaoFuncionalidade("ORCAMENTO_ENTREGA", "INCLUIR")
        const alterar = await permitidoAcaoFuncionalidade("ORCAMENTO_ENTREGA", "ALTERAR")
        if (isMounted.current) {
            setPermitidoIncluir(incluir)
            setPermitidoAlterar(alterar)
        }
    }

    const obterDadosEntrega = async () => {
        try {
            globalMU.blockUI({ tryPassiveLoading: true })
            const dados = await microuniversoApi.Orcamento.obterDadosEntrega({
                identificadorOrcamento: orcamento.IdentificadorOrcamento,
                tipoOrcamento: orcamento.TipoOrcamento,
                codigofilialVenda: orcamento.CodigoFilialOrcamento
            })
            if (isMounted.current) {
                setDados({
                    ...dados,
                    DadosEntrega: {
                        ...dados?.DadosEntrega,
                        ManterReserva: orcamento.ManterReserva, // 455920/74856
                        DataPrevisaoEntrega: globalMU.converterDataHoraFormatoENComTParaDataFormatoEN(dados?.DadosEntrega.DataPrevisaoEntrega),
                        DataMarcadaEntrega: globalMU.converterDataHoraFormatoENComTParaDataFormatoEN(dados?.DadosEntrega.DataMarcadaEntrega),
                    }
                })
            }
        }
        finally {
            globalMU.unblockUI()
        }
    }

    const obterDadosTransportadora = async () => {
        try {
            globalMU.blockUI({ tryPassiveLoading: true })

            const _dadosTransportadora = await microuniversoApi.Orcamento.obterDadosTransportadora({
                identificadorOrcamento: orcamento.IdentificadorOrcamento,
                tipoOrcamento: orcamento.TipoOrcamento,
            })

            if (isMounted.current) setDadosTransportadora(_dadosTransportadora)
        } finally {
            globalMU.unblockUI()
        }
    }

    const obterFretes = async () => {
        try {
            if (valorParametro('UTILIZA_FRETE_CARGA') === "S")
            {
                const _fretes = await microuniversoApi.Orcamento.ListarFretes(orcamento.IdentificadorOrcamento)
                if (isMounted.current) setFretes(_fretes)
            }
        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {

        }
    }

    const obterTiposEntrega = async () => {
        try {
            globalMU.blockUI()
            const _tiposEntrega = await microuniversoApi.Orcamento.ListarTiposEntrega(orcamento.IdentificadorOrcamento)
            if (isMounted.current) setTiposEntrega(_tiposEntrega)
        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI()
        }

    }

    const limparDados = () => {
        if (telaExibida === "Entrega") {
            setDados(dadosAntigos => ({
                ...dadosAntigos,
                DadosEntrega: {
                    ...dadosAntigos.DadosEntrega,
                    DataMarcadaEntrega: "",
                    DataPrevisaoEntrega: "",
                    TurnoEntrega: "",
                }
            }))
        }
        if (telaExibida === "Transportadora") {
            setDadosTransportadora(dadosAntigos => ({
                ...dadosAntigos,
                Transportadora: {
                    CodigoRoteiroEntrega: "",
                    CodigoTransportadora: "",
                    CodigoIndicadorDePresenca: "", // 458066
                    TipoTransportadora: "",
                    CodigoTransportadoraRedespacho: "",
                    TipoFrete: "",
                    ClassificacaoFrete: "",
                    ValorCustoFrete: 0,
                    HabilitaEdicaoCustoFrete: false,
                    CustoFretePendente: false,
                    Transforming: false,
                },
            }))
        }
    }

    const salvarEntrega = async (dados: Entrega) => {
        try {

            globalMU.blockUI({ tryPassiveLoading: true })
            if (dados.DataMarcadaEntrega?.length > 0 && dados.DataPrevisaoEntrega?.length > 0) {
                globalMU.showErrorMessage('Não é possível informar data marcada de entrega com data prevista preenchida. </br>Veja o parâmetro: "Utiliza tratamento diferenciado para datas marcadas e previstas no orçamento"')
                return
            }
            await atualizarEntrega({ dados })
            globalMU.showSuccessMessage('Dados da entrega atualizados com sucesso.')
            store.dispatch(gravarTelasAlteradasSalvaAction("telaEntrega_entrega"))

            if( orcamento.ItensOrcamento.filter(item => item.DataPrevisaoEntrega?.substring(0,10) != dados.DataPrevisaoEntrega?.substring(0,10) ).length > 0 ) {
                if ( valorParametro('DEFINIR_PREVISAO_ENTREGA_POR_ITEM') === "S" ) {//477908
                    globalMU.showWarnMessage('Alguns itens do orçamento possuem data de previsão de entrega diferente da capa do pedido. </br>Verifique se deseja replicar a data de previsao da capa para os itens.')
                }
            }

        }
        catch (e) {
            globalMU.showErrorMessage(e.Error)
        } finally {
            globalMU.unblockUI()
        }
    }

    const replicarData = async (dados: Entrega, alterarDataPrevista: boolean) => {
        try {
            globalMU.blockUI({ tryPassiveLoading: true })
            await atualizarEntrega({ dados })
            const result = await microuniversoApi.Orcamento.ReplicarDataEntrega(dados, alterarDataPrevista)
            if (result && !("Error" in result)) {
                const itens = result.ItensOrcamento
                const valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL = store.getState().parametros?.["ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL"]
                store.dispatch(atualizarItensAction({ itens, acao: "SOBRESCREVER", corPorAmbiente: store.getState().corPorAmbiente, valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL }))
                globalMU.showSuccessMessage('Dados da entrega atualizados com sucesso.')
            }
        }
        catch (e) {
            globalMU.showErrorMessage(e.Error)
        } finally {
            globalMU.unblockUI()
        }
    }

    const salvarTransportadora = async (dados: Transportadora) => {
        try {
            globalMU.blockUI({ tryPassiveLoading: true })

            if (dados.CodigoTransportadora == "Selecione") dados.CodigoTransportadora = "";
            if (dados.CodigoTransportadoraRedespacho == "Selecione") dados.CodigoTransportadoraRedespacho = "";
            if (dados.CodigoRoteiroEntrega == "Selecione") dados.CodigoRoteiroEntrega = "";
            if (dados.TipoFrete == "Selecione") dados.TipoFrete = "";

            if (dadosTransportadora.RoteiroObrigatorio && dadosTransportadora.PermitirAlterarRoteiro && (dados.CodigoRoteiroEntrega.length === 0 || !dados.CodigoRoteiroEntrega)) {
                globalMU.showErrorMessage('Campo "Roteiro" é obrigatório.')
                return;
            }
            const transportadora = await DefinirTransportadora({
                identificadorOrcamento: orcamento.IdentificadorOrcamento,
                tipoOrcamento: orcamento.TipoOrcamento,
                transportadora: dados
            })
            if (transportadora && !("Error" in transportadora)) {
                if (isMounted.current) {
                    setDadosTransportadora({
                        ...dadosTransportadora,
                        Transportadora: transportadora
                    })
                }
                globalMU.showSuccessMessage('Transportadora definida com sucesso')
                store.dispatch(gravarTelasAlteradasSalvaAction("telaEntrega_transportadora"))
            }
        }
        catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI()
        }
    }
    const alterarTela = (nomeTela: NomeTela) => {
        setTelaExibida(nomeTela)
        if (!permitidoFrete && nomeTela === 'Frete') {
            globalMU.showErrorMessage('Ação não permitida')
            return;
        }
        if (valorParametro('UTILIZA_FRETE_CARGA') !== "S" && nomeTela === 'Frete') {
            globalMU.showWarnMessage('Sistema não está configurado para utilizar tratamento de Frete/Carga no orçamento')
            return;
        }
        if (nomeTela === "Tipo Entrega" && (tiposEntrega?.length <= 0 || !tiposEntrega)) {
            globalMU.showWarnMessage("Nenhum registro encontrado")
            return;
        }
    }

    const handleAlterarValorEntrega = useCallback((entrega: Entrega) => {
        setDados(prev => ({ ...prev, DadosEntrega: entrega }))
        store.dispatch(gravarTelasAlteradasNaoSalvaAction("telaEntrega_entrega"))
        // 491123 — captura a edição ainda não aplicada (aba-entrega.tsx só salva no servidor ao
        // clicar em "Aplicar") para o snapshot de recuperação; ver orcamentoEmAndamentoSlice.ts.
        // 482572 — o snapshot é aplicado direto no PRG via EditarRestaurarDadosPendentes
        // (orcamentobase.prg::_RestaurarDadosPendentesClassesFilhasAposItens), que atribui
        // toJsonRestaurar._TurnoEntrega direto em cTurnoEntrega sem nenhuma conversão — precisa
        // já chegar como o primeiro caractere ('M'/'T'/'N'/'I', ver AgTransformacao::
        // ObterDescricaoTurnoEntrega), diferente do fluxo normal de "Aplicar"
        // (AtualizarEntrega -> OrcamentoRulesFenixWrapper.AtualizarEntrega), que converte o código
        // numérico do enum TurnosEntrega via turnoEntrega?.ToString().Left(1).ToUpper().
        const turnoSelecionado = dados.TurnosEntrega?.find(t => String(t.Value) === String(entrega.TurnoEntrega))
        store.dispatch(atualizarCamposPendentesOrcamentoEmAndamentoAction({
            TurnoEntrega: turnoSelecionado ? turnoSelecionado.Description.charAt(0).toUpperCase() : entrega.TurnoEntrega,
            ManterReserva: entrega.ManterReserva,
            EntregaExpressa: entrega.EntregaExpressa,
            BloquearDesdobramento: entrega.BloquearDesdobramento,
            DataPrevisaoEntrega: entrega.DataPrevisaoEntrega,
            DataMarcadaEntrega: entrega.DataMarcadaEntrega,
        }))
    }, [dados.TurnosEntrega])

    const handleAlterarValorTransportadora = useCallback((transportadora: Transportadora) => {
        setDadosTransportadora(prev => ({ ...prev, Transportadora: transportadora }))
        store.dispatch(gravarTelasAlteradasNaoSalvaAction("telaEntrega_transportadora"))
        // 491123 — idem: aba-transportadora.tsx também só salva no servidor ao clicar em "Aplicar".
        store.dispatch(atualizarCamposPendentesOrcamentoEmAndamentoAction({
            CodigoTransportadora: transportadora.CodigoTransportadora,
            CodigoTransportadoraRedespacho: transportadora.CodigoTransportadoraRedespacho,
            TipoFrete: transportadora.TipoFrete,
            CodigoRoteiroEntrega: transportadora.CodigoRoteiroEntrega,
            CodigoIndicadorDePresenca: transportadora.CodigoIndicadorDePresenca,
        }))
    }, [])

    const parametrosRef = useRef(parametros)
    parametrosRef.current = parametros

    const handleEditarFrete = useCallback((frete: Frete) => {
        renderizarComponentReact(
            <EditarFreteContainer frete={frete} />,
            "conteudo-pagina",
            true
        )
    }, [])

    const handleEditarTipoEntrega = useCallback((tipoEntrega: TipoEntrega) => {
        renderizarComponentReact(
            <EditarTipoEntregaContainer tipoEntrega={tipoEntrega}
                mostrarNomeComoCodigo={parametrosRef.current.find(p => p.Nome == "CHAVE_MOVIMENTACAO_ORCAMENTO")?.Valor == "C"}
            />,
            "conteudo-pagina",
            true
        )
    }, [])

    useEffect(() => {
        atualizarParametros()
    }, [])

    useEffect(() => {
        if (orcamento?.Numero != null && parametros != undefined && parametros != null && parametros.length > 0) {
            obterDadosEntrega()
            atualizarPermissoes()
            obterDadosTransportadora()
            obterFretes()
            obterTiposEntrega()
            obterPermissoes()
        }
    }, [parametros])

    useEffect(() => {
        setTelaExibida(props.telaDefault ?? "Entrega")
    }, [props.telaDefault])

    useEffect(() => {
        if (dados != null && dados.DadosEntrega != null && dadosTransportadora != null && parametros != null
            && parametros.length > 0 && dadosTransportadora.Transportadoras.length > 0 && !obtendoPemissoes
        )
        {

        if (orcamento.NumeroDiasMaximoParaPrevisaoEntrega && orcamento.NumeroDiasMaximoParaPrevisaoEntrega > 0) {
            const dataMaxima = new Date()
            dataMaxima.setDate(dataMaxima.getDate() + orcamento.NumeroDiasMaximoParaPrevisaoEntrega)
            setDataMaximaParaPrevisaoEntrega({ year: dataMaxima.getFullYear(), month: dataMaxima.getMonth() + 1, day: dataMaxima.getDate() })
        }


        setCarregando(false)
        globalMU.unblockUI()
        }
    }, [dados, dadosTransportadora, parametros, obtendoPemissoes])

    return (
        <>
            {carregando && <div><span>Carregando... Aguarde!</span></div>}
            {!carregando &&

                <TelaEntrega
                    somenteLeitura={orcamento.SomenteLeitura}
                    dataMaximaParaPrevisaoEntrega={dataMaximaParaPrevisaoEntrega}
                    mostrarGuiaFrete={valorParametro('UTILIZA_FRETE_CARGA') === "S"}
                    permitidoEditarFrete={permitidoEditarFrete}
                    permitidoEditarTipoEntrega={permitidoEditarTipoEntrega}
                    permitidoAlterarEntrega={permitidoAlterarEntrega}
                    onAlterarValorEntrega={handleAlterarValorEntrega}
                    onAlterarValorTransportadora={handleAlterarValorTransportadora}
                    onLimpar={limparDados}
                    telaExibida={telaExibida}
                    onAlterarTela={alterarTela}
                    todosTurnos={dados.TurnosEntrega}
                    entrega={dados.DadosEntrega}
                    onAplicarEntrega={salvarEntrega}
                    definirPrevisaoEntregaPorItem={valorParametro('DEFINIR_PREVISAO_ENTREGA_POR_ITEM') === "S"}
                    vendaComEntregaPosterior={valorParametroPorFilial('VENDA_COM_ENTREGA_POSTERIOR') === "S"}
                    habilitarInputsAbaEntrega={orcamento.TipoOrcamento === 0 && permitidoIncluir || orcamento.TipoOrcamento !== 0 && permitidoAlterar}
                    habilitarExpedicaoExpressa={dados?.DadosEntrega?.HabilitarExpedicaoExpressa}
                    usarSeparacaoExpedicaoExpressa={dados?.ParametroExpedicaoExpressa != null ?
                        (dados?.ParametroExpedicaoExpressa?.includes("EL") || dados?.ParametroExpedicaoExpressa?.includes("EO")) : false}
                    usarDefinirPrevisaoEntregaPorItem={valorParametro('DEFINIR_PREVISAO_ENTREGA_POR_ITEM') === "S" && orcamento.ItensOrcamento.length > 0}
                    replicarData={replicarData}
                    incluir={permitidoIncluir}
                    alterar={permitidoAlterar}
                    listaTransportadora={dadosTransportadora?.Transportadoras}
                    listaRedespacho={dadosTransportadora?.TransportadorasRedespacho}
                    listaTipoFrete={dadosTransportadora?.TiposFrete}
                    listaRoteiro={dadosTransportadora?.Roteiros}
                    listaIndicadoresDePresenca={dadosTransportadora?.IndicadoresDePresenca} // 458066
                    transportadora={dadosTransportadora?.Transportadora}
                    onAplicarTransportadora={salvarTransportadora}
                    permitirAlterarRoteiro={dadosTransportadora?.PermitirAlterarRoteiro}
                    utilizaCalculoFreteFaixaMarkup={valorParametro('UTILIZA_CALCULO_FRETE_FAIXA_MARKUP')}
                    habilitaEdicaoCustoFrete={valorParametro('UTILIZA_CALCULO_FRETE_FAIXA_MARKUP') == "S"}  // 449298 -> {dadosTransportadora?.Transportadora?.HabilitaEdicaoCustoFrete}
                    custoFretePendente={dadosTransportadora?.Transportadora?.CustoFretePendente}
                    parametroUtilizaCargaFrete={valorParametro('UTILIZA_FRETE_CARGA')}
                    vendaComEntregaExpressa={valorParametro('VENDA_ENTREGA_EXPRESSA') === "S"}
                    todosFrete={fretes}
                    onEditarFrete={handleEditarFrete}
                    tiposEntrega={tiposEntrega}
                    mostrarNomeComoCodigo={valorParametro("CHAVE_MOVIMENTACAO_ORCAMENTO") == "C"}
                    onEditarTipoEntrega={handleEditarTipoEntrega}
                />
            }
        </>
    )

}
